// hydrate 캐시 블록 한 벌 — 빌드 스크립트(scripts/prerender.mjs)가 TS 를 못 읽어 순수 .mjs 로 두고 Worker SSR·SPA 가 같이 쓴다.

// 미리 그린 HTML 에 실린 캐시 블록의 id — 프리렌더와 Worker SSR 이 같은 이름으로 내고 main.tsx 가 읽는다.
export const PRERENDER_STATE_ID = "buildpy-prerender";

/** @type {Record<string, string>} */
const ESCAPES = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" };

/** @param {string} text @returns {string} */
export const escapeHtml = (text) => text.replace(/[&<>"']/g, (ch) => ESCAPES[ch]);

// <script> 안 JSON — </script> 로 끊기지 않게 < 를, 옛 JS 파서가 줄바꿈으로 읽는 U+2028·U+2029 를 바꾼다.
/** @param {unknown} value @returns {string} */
export const jsonForScript = (value) =>
  JSON.stringify(value).replace(/</g, "\\u003c").replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");

/** @param {string} url @param {unknown} state @returns {string} */
export const stateScript = (url, state) =>
  `<script type="application/json" id="${PRERENDER_STATE_ID}" data-url="${escapeHtml(url)}">${jsonForScript(state)}</script>`;
